// extracted by mini-css-extract-plugin
export default {"description":"Description_description__0fBJ1","dark":"Description_dark__rJKpH","white":"Description_white__iPfIo"};